import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IconButton from '@material-ui/core/IconButton';
import Utils from './Utils';

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    margin: {
        width: '220px',
        textTransform: 'none',
        textAlign: 'left',
      },

  }));

  
  export default function DetailTableDelete(props) {
    
    function  handleClick(myId) {
      console.log('Klik:',myId );
  
      var formData = new FormData();
        formData.append('acceptReservation', true);
        formData.append('ReservationId', myId );
        
        let fetchData = { 
          method: 'POST', body: formData,      
          headers: {
             headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          },  
        }
  
      // A posílám
      fetch(Utils.getURL(), fetchData)   
      .then(response => response.json())
      .then(data => {          
          if ( data["success"]) {
          // console.log('Stav:', "OK");  
           // zrefreshuji
          props.onRefresh();
        }
          else{
                }            
      })
      .catch((error) => {
        console.error('Chyba:', error);
      });
  
    }   
    




        const classes = useStyles();    
        return (
            <div>
                
                <div className={classes.root}>
                 {props.myData.map((item, index) =>
                     <Button className={classes.margin} variant="contained" >
                        {"Číslo:" + item.res_id }
                        <br></br>       
                        {"Jméno:" + item.res_name + " "}
                 <br></br>{"(Osob:"+ item.res_count + ")"}
                 
                      <IconButton color="primary" variant="contained" 
                        onClick={() => handleClick(item.res_id)}
                        >
                          <AddBoxIcon fontSize="large" ></AddBoxIcon>
                      </IconButton>
                     </Button>
                    )
                    }
                </div>

            </div>
        )
    }

